module.exports = __webpack_public_path__ + "static/media/mapPoint.1020f470.svg";